export default __webpack_public_path__ + "static/media/background.5e7c05f6.jpg";